"use client";

import Image from "next/image";
import Link from "next/link";
import type { ComponentConfig } from "@puckeditor/core";
import { businessData } from "@/data/business";
import { getCatalogProductsByCategory } from "@/data/product-catalog";

type ProductCatalogProps = {
  heading?: string;
  intro?: string;
};

export const ProductCatalogBlock: ComponentConfig<ProductCatalogProps> = {
  label: "Product Catalog",
  fields: {
    heading: { type: "text", label: "Heading" },
    intro: { type: "textarea", label: "Introduction" },
  },
  defaultProps: {
    heading: "Private-Label Formulation Catalog",
    intro: "Explore production-ready formulation directions across nine specialist categories. Every formula can be adjusted for active level, texture, fragrance, packaging, and target market.",
  },
  render: ({ heading, intro }) => (
    <section className="sec product-catalog" id="catalog">
      <div className="container">
        <div className="sec-head">
          <h1>{heading}</h1>
          <p>{intro}</p>
        </div>

        <nav className="catalog-jump" aria-label="Product categories">
          {businessData.categories.map((category) => (
            <a key={category.id} href={`#catalog-${category.id}`}>{category.title}</a>
          ))}
        </nav>

        <div className="catalog-groups">
          {businessData.categories.map((category) => {
            const products = getCatalogProductsByCategory(category.id);
            return (
              <section className="catalog-group" id={`catalog-${category.id}`} key={category.id}>
                <div className="catalog-group-head">
                  <div>
                    <h2>{category.title}</h2>
                    <p>{category.tagline}</p>
                  </div>
                  <Link href={category.href}>Category details</Link>
                </div>
                <div className="catalog-product-grid">
                  {products.map((product) => (
                    <Link className="catalog-product-card" href={`/products/${product.slug}`} key={product.slug}>
                      <span className="catalog-product-media">
                        <Image src={product.image} alt="" fill sizes="(max-width: 640px) 40vw, 180px" />
                      </span>
                      <span className="catalog-product-copy">
                        <span className="catalog-product-sku">{product.sku}</span>
                        <strong>{product.name}</strong>
                        <span>MOQ: 500–1000 pc</span>
                      </span>
                      <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                        <path d="M5 12h14M13 6l6 6-6 6" />
                      </svg>
                    </Link>
                  ))}
                </div>
              </section>
            );
          })}
        </div>
      </div>
    </section>
  ),
};
